import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const WorkspaceSettingsVisibilityPopoverContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceSettingsVisibilityPopoverContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"WorkspaceSettingsVisibilityPopoverContent","document":WorkspaceSettingsVisibilityPopoverContentDocument}} as const;
export type WorkspaceSettingsVisibilityPopoverContentQueryVariables = Types.Exact<{
  orgId: Types.Scalars['ID'];
}>;


export type WorkspaceSettingsVisibilityPopoverContentQuery = (
  { __typename: 'Query' }
  & { organization?: Types.Maybe<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'domainName' | 'id'>
    & { domain?: Types.Maybe<(
      { __typename: 'DomainOrganization' }
      & Pick<Types.DomainOrganization, 'displayName'>
    )> }
  )> }
);

/**
 * __useWorkspaceSettingsVisibilityPopoverContentQuery__
 *
 * To run a query within a React component, call `useWorkspaceSettingsVisibilityPopoverContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceSettingsVisibilityPopoverContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceSettingsVisibilityPopoverContentQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useWorkspaceSettingsVisibilityPopoverContentQuery(
  baseOptions: TrelloQueryHookOptions<
    WorkspaceSettingsVisibilityPopoverContentQuery,
    WorkspaceSettingsVisibilityPopoverContentQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: WorkspaceSettingsVisibilityPopoverContentDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    WorkspaceSettingsVisibilityPopoverContentQuery,
    WorkspaceSettingsVisibilityPopoverContentQueryVariables
  >(WorkspaceSettingsVisibilityPopoverContentDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useWorkspaceSettingsVisibilityPopoverContentLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    WorkspaceSettingsVisibilityPopoverContentQuery,
    WorkspaceSettingsVisibilityPopoverContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkspaceSettingsVisibilityPopoverContentQuery,
    WorkspaceSettingsVisibilityPopoverContentQueryVariables
  >(WorkspaceSettingsVisibilityPopoverContentDocument, options);
}
export type WorkspaceSettingsVisibilityPopoverContentQueryHookResult = ReturnType<
  typeof useWorkspaceSettingsVisibilityPopoverContentQuery
>;
export type WorkspaceSettingsVisibilityPopoverContentLazyQueryHookResult = ReturnType<
  typeof useWorkspaceSettingsVisibilityPopoverContentLazyQuery
>;
export type WorkspaceSettingsVisibilityPopoverContentQueryResult = Apollo.QueryResult<
  WorkspaceSettingsVisibilityPopoverContentQuery,
  WorkspaceSettingsVisibilityPopoverContentQueryVariables
>;
